<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="dialogFormVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form size="mini" :model="editForm" ref="editForm" label-position="right" label-width="100px">
        <el-form-item label="方案标题：" prop="solutionTitle" :rules="{required: true,message: '请输入方案名称'}">
          <el-input v-model="editForm.solutionTitle"
                    placeholder="请输入方案标题"></el-input>
        </el-form-item>
        <el-form-item label="方案封面：">
          <div style="width: 120px;height: 80px;  overflow: hidden;border: 1px dashed #dddddd;border-radius: 5px;">
            <div class="item img-select"
                 style="width: 120px;height: 80px;display: flex;justify-content: center;align-items: center;"
                 @click="openProductUpload('image', 'header')">
              <i class="el-icon-plus" v-if="!editForm.coverPath"></i>
              <img
                style="max-height: 100%; max-width: 100%;"
                v-img-url="editForm.coverPath" v-if="editForm.coverPath"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="方案作物：" prop="cropList"
                      :rules="{required: true,message: '请添加方案作物'}">
          <el-tag :key="item.id" v-for="(item,index) in editForm.cropList" closable
                  :disable-transitions="false"
                  class="margin-right-10"
                  @close="handleClose(editForm.cropList,index)">{{ item }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveCropInput"
            size="mini"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>
          <el-button size="mini" type="primary" @click="onCropChoose">添加作物</el-button>
        </el-form-item>
        <el-form-item label="方案时期：" prop="periodIds">
          <el-tag :key="item.id" v-for="(item,index) in editForm.periodList" closable
                  :disable-transitions="false"
                  class="margin-right-10"
                  @close="handleClose(editForm.periodList,index)">{{ item }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputPeriodVisible"
            v-model="inputPeriodValue"
            ref="savePeriodInput"
            size="mini"
            @keyup.enter.native="handlePeriodInputConfirm"
            @blur="handlePeriodInputConfirm"
          ></el-input>
          <el-button size="mini" type="primary" @click="onPeriodChoose">添加时期</el-button>
        </el-form-item>
        <el-form-item label="防治对象：" prop="periodIds">
          <el-tag :key="item.id" v-for="(item,index) in editForm.preventionTargetList" closable
                  :disable-transitions="false"
                  class="margin-right-10"
                  @close="handleClose(editForm.preventionTargetList,index)">{{ item }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputTargetVisible"
            v-model="inputTargetValue"
            ref="saveTargetInput"
            size="mini"
            @keyup.enter.native="handleTargetInputConfirm"
            @blur="handleTargetInputConfirm"
          ></el-input>
          <el-button size="mini" type="primary" @click="onTargetChoose">添加防治对象</el-button>
        </el-form-item>
        <el-form-item label="方案说明：">
          <el-input size="mini" type="textarea" rows="4" resize="false" v-model="editForm.solutionDesc"
                    placeholder="请输入方案说明"></el-input>
        </el-form-item>

        <el-form-item label="亩用水量：" prop="waterConsumption"
                      :rules="{required: true,message: '请添加亩用水量'}">
          <el-input-number size="mini" v-model="editForm.waterConsumption" :controls="false" :precision="2" :min="0.01"
                           placeholder="请输入亩用水量"></el-input-number>
          <span class="margin-left-15">公斤</span>
        </el-form-item>

        <el-form-item label="方案产品：" prop="cropSolutionProductList"
                      :rules="{required: true,message: '请添加方案产品'}">
          <el-table border size="mini" :data="editForm.cropSolutionProductList">
            <el-table-column prop="productName" label="产品" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.productName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="稀释倍数" prop="dilutionRatio" align="center" width="160px">
              <template slot-scope="scope">
                <el-input-number :min="0.01" :precision="2"
                                 v-model="editForm.cropSolutionProductList[scope.$index].dilutionRatio"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="120px">
              <template slot="header" slot-scope="scope">
                <el-button
                  type="text"
                  plain
                  size="mini"
                  @click="handleProductAdd"
                >添加产品
                </el-button>
              </template>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="handleProductUpdate(scope.row,scope.$index)"
                >修改
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleDelete(scope.$index)"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-form-item>
        <el-form-item label="应用图例：">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="editForm.attachLists">
              <transition-group>
                <div class="item" v-for="(item, index) in editForm.attachLists" :key="item">
                  <img v-img-url="item.filePath"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                    class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('image', 'imageList')"><i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="addSubmit">确 定</el-button>
      </div>

      <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
        上传图片
      </Upload>
    </el-dialog>
    <!--选择商品-->
    <ProductSelect :isProduct="isproduct" :islist="islist" :dataType="0" @closeDialog="closeProductDialogFunc($event)">
    </ProductSelect>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Upload from '@/components/file/Upload'
import ProductSelect from '@/components/product/Product'
import CropSolutionApi from '@/api/cropsolution.js'

export default {
  name: 'solutionEditDialog',
  components: {
    draggable,
    Upload,
    ProductSelect
  },
  data () {
    return {
      dialogTitle: '',
      dialogVisible: false,
      solutionId: 0,
      editForm: {
        solutionTitle: '',
        coverId: 0,
        coverPath: '',
        cropList: [],
        periodList: [],
        preventionTargetList: [],
        solutionDesc: '',
        waterConsumption: undefined,
        remark: '',
        attachLists: [],
        cropSolutionProductList: []
      },
      isProductUpload: false,
      file_name: 'image',
      config: {},
      inputVisible: false,
      inputValue: '',
      inputPeriodVisible: false,
      inputPeriodValue: '',
      inputTargetVisible: false,
      inputTargetValue: '',
      /*是否打开产品弹出层*/
      isproduct: false,
      islist: true,
      selRow: null,
      selIndex: undefined
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    show (editForm) {
      if (editForm.id) {
        this.dialogTitle = '编辑作物方案'
      } else {
        this.dialogTitle = '新增作物方案'
      }
      this.editForm = editForm
      this.solutionId = editForm.id
      this.dialogVisible = true
    },

    dialogFormVisible () {
      this.editForm = {
        solutionTitle: '',
        coverId: 0,
        coverPath: '',
        cropList: [],
        periodList: [],
        preventionTargetList: [],
        solutionDesc: '',
        waterConsumption: '',
        remark: '',
        attachLists: [],
        cropSolutionProductList: []
      }
      this.solutionId = 0
    },

    addSubmit () {
      let self = this
      self.$refs.editForm.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(self.editForm))
          if (self.solutionId) {
            CropSolutionApi.editCropSolution(params, true).then(res => {
              if (res.code === 1) {
                self.$emit('solutionChange')
                self.dialogVisible = false
              }
              self.$message.info(res.msg)
            })
          } else {
            CropSolutionApi.addCropSolution(params, true).then(res => {
              if (res.code === 1) {
                self.$emit('solutionChange')
                self.dialogVisible = false
              }
              self.$message.info(res.msg)
            })
          }
        }
      })
    },

    returnProductImgsFunc (e) {
      if (e != null) {
        // 兼容后端
        if (e.length > 0) {
          if (this.file_name === 'imageList') {
            this.editForm.attachLists = this.editForm.attachLists.concat(e)
          } else if (this.file_name === 'header') {
            this.editForm.coverPath = e[0].filePath
            this.editForm.coverId = e[0].fileId
          }
        }
      }
      this.isProductUpload = false
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.editForm.attachLists.splice(index, 1)
    },
    /*打开上传图片*/
    openProductUpload: function (file_type, file_name) {
      this.file_name = file_name
      if (this.file_name === 'imageList') {
        this.config = {
          total: 9,
          fileType: file_type
        }
      } else if (this.file_name === 'header') {
        this.config = {
          total: 1,
          fileType: file_type
        }
      }

      this.isProductUpload = true
    },
    handleClose (list, index) {
      list.splice(index, 1)
    },
    handleProductAdd () {
      this.islist = true
      this.isproduct = true
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.editForm.cropList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    onCropChoose () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveCropInput.$refs.input.focus()
      })
    },
    handlePeriodInputConfirm () {
      let inputValue = this.inputPeriodValue
      if (inputValue) {
        this.editForm.periodList.push(inputValue)
      }
      this.inputPeriodVisible = false
      this.inputPeriodValue = ''
    },
    onPeriodChoose () {
      this.inputPeriodVisible = true
      this.$nextTick(_ => {
        this.$refs.savePeriodInput.$refs.input.focus()
      })
    },
    handleTargetInputConfirm () {
      let inputValue = this.inputTargetValue
      if (inputValue) {
        this.editForm.preventionTargetList.push(inputValue)
      }
      this.inputTargetVisible = false
      this.inputTargetValue = ''
    },
    onTargetChoose () {
      this.inputTargetVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTargetInput.$refs.input.focus()
      })
    },
    closeProductDialogFunc (e) {
      if (e.type !== 'error') {
        let proList = JSON.parse(JSON.stringify(this.editForm.cropSolutionProductList)) || []
        const map = proList.reduce((acc, item) => {
          acc.set(item.productId, item)
          return acc
        }, new Map())
        if (this.islist) {
          if (e.params && e.params.length) {
            e.params.map(item => {
              let productId = item.productId
              if (!map.has(productId)) {
                let pItem = {
                  productId: productId,
                  productName: item.productName,
                  dilutionRatio: 1000
                }
                this.editForm.cropSolutionProductList.push(pItem)
              }
            })
          }
        } else {
          let item = e.params
          if (!map.has(item.productId)) {
            Object.assign(this.selRow, {
              productId: item.productId,
              productName: item.productName,
              dilutionRatio: 1000.00
            })
          } else {
            console.log(this.selRow)
            if (this.selRow.productId !== item.productId) {
              this.editForm.cropSolutionProductList.splice(this.selIndex, 1)
            }
          }
        }
      }
      this.isproduct = false
    },
    handleProductUpdate (row, index) {
      this.islist = false
      this.selRow = row
      this.selIndex = index
      this.isproduct = true
    },
    handleDelete (index) {
      this.editForm.cropSolutionProductList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 80px;
  height: 80px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.input-new-tag {
  width: 90px;
  margin-right: 10px;
  vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/crop/solution/period/component/solutionEditDialog.vue